'use strict';

var _caligramReact = require('caligram-react');

var _reactRouter = require('react-router');

var _bullet = require('./icons/bullet.svg');

var _bullet2 = _interopRequireDefault(_bullet);

var _checkmark = require('./icons/checkmark.svg');

var _checkmark2 = _interopRequireDefault(_checkmark);

var _chevronDown = require('./icons/chevronDown.svg');

var _chevronDown2 = _interopRequireDefault(_chevronDown);

var _chevronLeft = require('./icons/chevronLeft.svg');

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronRight = require('./icons/chevronRight.svg');

var _chevronRight2 = _interopRequireDefault(_chevronRight);

var _clock = require('./icons/clock.svg');

var _clock2 = _interopRequireDefault(_clock);

var _dollarSign = require('./icons/dollarSign.svg');

var _dollarSign2 = _interopRequireDefault(_dollarSign);

var _facebook = require('./icons/facebook.svg');

var _facebook2 = _interopRequireDefault(_facebook);

var _hideRecurrences = require('./icons/hideRecurrences.svg');

var _hideRecurrences2 = _interopRequireDefault(_hideRecurrences);

var _linkedIn = require('./icons/linkedIn.svg');

var _linkedIn2 = _interopRequireDefault(_linkedIn);

var _minus = require('./icons/minus.svg');

var _minus2 = _interopRequireDefault(_minus);

var _person = require('./icons/person.svg');

var _person2 = _interopRequireDefault(_person);

var _pin = require('./icons/pin.svg');

var _pin2 = _interopRequireDefault(_pin);

var _plus = require('./icons/plus.svg');

var _plus2 = _interopRequireDefault(_plus);

var _printer = require('./icons/printer.svg');

var _printer2 = _interopRequireDefault(_printer);

var _showRecurrences = require('./icons/showRecurrences.svg');

var _showRecurrences2 = _interopRequireDefault(_showRecurrences);

var _twitter = require('./icons/twitter.svg');

var _twitter2 = _interopRequireDefault(_twitter);

var _x = require('./icons/x.svg');

var _x2 = _interopRequireDefault(_x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line id-length

_caligramReact.CaligramReact.config({
  // This configuration object will be passed to caligram-react.
  // See https://gitlab.com/territoires/caligram-react/blob/master/src/config.js
  icons: {
    bullet: _bullet2.default,
    checkmark: _checkmark2.default,
    chevronDown: _chevronDown2.default,
    chevronLeft: _chevronLeft2.default,
    chevronRight: _chevronRight2.default,
    clock: _clock2.default,
    dollarSign: _dollarSign2.default,
    facebook: _facebook2.default,
    hideRecurrences: _hideRecurrences2.default,
    linkedIn: _linkedIn2.default,
    minus: _minus2.default,
    person: _person2.default,
    pin: _pin2.default,
    plus: _plus2.default,
    printer: _printer2.default,
    showRecurrences: _showRecurrences2.default,
    twitter: _twitter2.default,
    x: _x2.default
  },
  linkComponent: _reactRouter.Link
});


//////////////////
// WEBPACK FOOTER
// ./src/caligramReact.js
// module id = 1103
// module chunks = 0